import { Action, ActionCreator } from 'redux'

import { IActionResetPagination, IActionSetPagination, PaginationActionTypes } from './types'

import { ILibPagination } from '@infologistics/frontend-libraries'

export const resetPagination: IActionResetPagination = {
  type: PaginationActionTypes.RESET_PAGINATION
}

export const setPagination: ActionCreator<Action> = (pagination: ILibPagination): IActionSetPagination => ({
  payload: pagination,
  type: PaginationActionTypes.SET_PAGINATION
})
